import { ScheduleTypeEnum } from "types";

import biWeeklySampleDates from "./dateGenerators/biWeekly";
import monthlySampleDates from "./dateGenerators/monthly";
import nthWeekdaySampleDates from "./dateGenerators/nthWeekday";
import particularDaySampleDates from "./dateGenerators/particularDay";
import twiceMonthlySampleDates from "./dateGenerators/twiceMonthly";
import weeklySampleDates from "./dateGenerators/weekly";

export default {
  [ScheduleTypeEnum.BI_WEEKLY]: biWeeklySampleDates,
  [ScheduleTypeEnum.MONTHLY]: monthlySampleDates,
  [ScheduleTypeEnum.NTH_WEEKDAY]: nthWeekdaySampleDates,
  [ScheduleTypeEnum.PARTICULAR_DAY]: particularDaySampleDates,
  [ScheduleTypeEnum.TWICE_MONTHLY]: twiceMonthlySampleDates,
  [ScheduleTypeEnum.WEEKLY]: weeklySampleDates,
};
